import React from 'react';
import Head from 'next/head';
import { string } from 'prop-types';
import { decodeEntities } from 'util/html';

/**
 * factory function to return a MetaTag component with desired props. because
 * all <meta /> tags are not created equal. defaults to:
 *
 *   <meta name="" content="" />
 *
 * @export
 * @param {Object} [defaults={}] defaults for meta tag
 * @param {String} [defaults.keyName='name'] the HTML attr to use for the 'name' key
 * @param {String} [defaults.valueName='content'] the HTML attr to use for the 'content' key
 * @returns {Function} factory function
 */
export default function createMetaTag(defaults = {}) {
  const { keyName = 'name', valueName = 'content' } = defaults;

  /**
   * MetaTag is a component that renders an "abstract" <meta /> tag (no
   * defined keyName and valueName)
   */
  function MetaTag(props) {
    const { name, value } = props;

    const metaProps = {
      [keyName]: name,
      // Decode entities to avoid double escaping, e.g. &amp;amp; React will
      // encode when setting the attribute value.
      [valueName]: decodeEntities(value)
    };

    return (
      <Head>
        <meta {...metaProps} />
      </Head>
    );
  }

  MetaTag.propTypes = {
    // name and value props are from the 'data' attr in our bundle item schema
    name: string.isRequired,
    value: string.isRequired
  };

  MetaTag.defaultProps = {};

  return MetaTag;
}
